import { IChipsOption } from '@cian/ui-kit';

/* Подписи живут здесь, а не в компоненте поля: их читают и поле формы, и карточка в модалке
   отправленной заявки, а два списка неизбежно разъедутся */
export const PROGRAMS_OPTIONS: IChipsOption<string>[] = [
  { label: 'Базовая', value: 'noProgram', dataTestId: 'program-basic' },
  { label: 'Семейная', value: 'family', dataTestId: 'program-family' },
  { label: 'ИТ-ипотека', value: 'it', dataTestId: 'program-it' },
];

export const PROGRAM_LABELS: Record<string, string> = Object.fromEntries(
  PROGRAMS_OPTIONS.map(({ value, label }) => [value, label]),
);

export const REAL_ESTATE_TYPE_LABELS: Record<string, string> = {
  newBuilding: 'Новостройка',
  secondary: 'Вторичка',
  houseBuilding: 'Строительство дома',
};
